import * as type from '../../../actions/index.types'

const initialState = {
    // List of cash & bank accounts
    listLoading: false,
    listData: [],
    listError: null,

    // Journal entries
    entriesLoading: false,
    entriesData: [],
    entriesError: null,

    // Summary
    summaryLoading: false,
    summaryData: null,
    summaryError: null,
};

export function CashBankReducer(state = initialState, action) {
    switch (action.type) {
        // Get List
        case type.GET_CASH_BANK_LIST:
            return { ...state, listLoading: true, listError: null }
        case type.GET_CASH_BANK_LIST_SUCCESS:
            return { ...state, listLoading: false, listData: action.payload?.data || [], listError: null }
        case type.GET_CASH_BANK_LIST_FAILURE:
            return { ...state, listLoading: false, listError: action?.message }

        // Get Entries
        case type.GET_CASH_BANK_ENTRIES:
            return { ...state, entriesLoading: true, entriesError: null }
        case type.GET_CASH_BANK_ENTRIES_SUCCESS:
            return { ...state, entriesLoading: false, entriesData: action.payload?.data || [], entriesError: null }
        case type.GET_CASH_BANK_ENTRIES_FAILURE:
            return { ...state, entriesLoading: false, entriesError: action?.message }

        // Get Summary
        case type.GET_CASH_BANK_SUMMARY:
            return { ...state, summaryLoading: true, summaryError: null }
        case type.GET_CASH_BANK_SUMMARY_SUCCESS:
            return { ...state, summaryLoading: false, summaryData: action.payload?.data || null, summaryError: null }
        case type.GET_CASH_BANK_SUMMARY_FAILURE:
            return { ...state, summaryLoading: false, summaryError: action?.message }

        // Clear State
        case type.CLEAR_CASH_BANK_STATE:
            return { ...initialState }

        default:
            return state
    }
}
